import { getGetImmaginiUidQueryKey, joinPath } from '@framework/api-client';
import { LanguageTag } from '@framework/i18n';
import { appConfig } from '../../../../core/appConfig';

export function getImageUrl(
  id: string | null | undefined,
  language: LanguageTag,
) {
  if (!id) return '';
  const uri = getGetImmaginiUidQueryKey(id)[0] as string;

  const additionalParams = `?lingua=${language}`;

  return joinPath([appConfig.apiBaseUrl, uri + additionalParams]);
}
